import { EventEmitter, NgZone } from '@angular/core';
import { BillingStatus, UserBilling } from '../../../../../models/Billing/billing-details';
import { CommonConstant } from '../../../../app.constants';
import { UserService } from '../../../../services/user.service';
import { AppSettings } from '../../../../utils/app-settings';
import { TranslateService } from '@ngx-translate/core';
import { CompanyStatus } from '../../../../../models/common';
var AccountTypeComponent = /** @class */ (function () {
    function AccountTypeComponent(userService, translate, _ngZone) {
        this.userService = userService;
        this.translate = translate;
        this._ngZone = _ngZone;
        this.afterUpdateSubscription = new EventEmitter();
        this.requestReloadBilling = new EventEmitter();
        this.symbolCurrencies = [
            {
                id: 1,
                name: CommonConstant.EUROPE_CURRENCY,
                code: CommonConstant.EUROPE_CURRENCY,
                symbol: CommonConstant.CURRENCY_SIGN.EURO
            },
            {
                id: 2,
                name: CommonConstant.US_CURRENCY,
                code: CommonConstant.US_CURRENCY,
                symbol: CommonConstant.CURRENCY_SIGN.USD
            },
            {
                id: 3,
                name: CommonConstant.POUND_CURRENCY_CODE,
                code: CommonConstant.POUND_CURRENCY_CODE,
                symbol: CommonConstant.CURRENCY_SIGN.POUND
            }
        ];
    }
    AccountTypeComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (typeof window['Chargebee'] === 'function') {
            this.cbInstance = window['Chargebee'].init({
                site: AppSettings.cbSite()
            });
            this.cbInstance.setPortalSession(function () {
                return _this.userService.getPortalSession(_this.userService.getCompanyId()).toPromise();
            });
        }
    };
    Object.defineProperty(AccountTypeComponent.prototype, "canShowInvoicedNextMonth", {
        get: function () {
            return this.userBilling && !this.userBilling.isLoading && this.userBilling.currency;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AccountTypeComponent.prototype, "canEditSubscription", {
        get: function () {
            return this.userBilling && !this.userBilling.isLoading
                && this.userService.isAgency
                && this.userBilling.canManageSubscription;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AccountTypeComponent.prototype, "hasValidSubscription", {
        get: function () {
            if (this.userService.isFreeUser()) {
                return true;
            }
            return this.userBilling && !this.userBilling.isLoading
                && (this.userBilling.status !== BillingStatus.IN_TRIAL || this.userBilling.isValidPayment);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AccountTypeComponent.prototype, "canViewSubscriptionId", {
        get: function () {
            return this.userBilling && !this.userBilling.isLoading
                && this.userService.isAdmin;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AccountTypeComponent.prototype, "isAccountInactive", {
        get: function () {
            return this.userBilling
                && (this.userBilling.customerStatus === CompanyStatus.BLOCKED || this.userBilling.customerStatus === CompanyStatus.CHURNED);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AccountTypeComponent.prototype, "isFutureAccount", {
        get: function () {
            return this.userBilling && this.userBilling.customerStatus === CompanyStatus.FUTURE;
        },
        enumerable: true,
        configurable: true
    });
    AccountTypeComponent.prototype.checkoutSubscription = function () {
        var _this = this;
        var companyId = this.userService.getCompanyId();
        this.cbInstance.openCheckout({
            hostedPage: function () {
                return _this.userService.generateCheckoutNewSubscription(companyId).toPromise();
            },
            layout: 'full_page',
            error: function (error) {
                _this.afterUpdateSubscription.emit({
                    isError: true,
                    message: _this.translate.instant('user_billing.checkout_subscription_error')
                });
            },
            success: function (hostedPageId) {
                // Call WS to retrieve the updated subscription data after paying success
                _this.loadBillingData();
            }
        });
    };
    AccountTypeComponent.prototype.openCustomerPortal = function () {
        var _this = this;
        this.cbInstance.createChargebeePortal().open({
            error: function (err) {
                _this.afterUpdateSubscription.emit({
                    isError: true,
                    message: _this.translate.instant('user_billing.open_customer_portal_error')
                });
            },
            close: function () {
                // Call WS to retrieve the updated subscription data
                _this.loadBillingData();
            }
        });
    };
    AccountTypeComponent.prototype.getCurrencySymbol = function (currencyCode) {
        var currency = this.symbolCurrencies.find(function (sc) { return sc.code === currencyCode; });
        return currency ? currency : currencyCode;
    };
    AccountTypeComponent.prototype.loadBillingData = function () {
        var _this = this;
        // this function is invoked by third-party library so nothing guarentee Angular detect changes immediately
        // using ngZone.run to make sure changeDetection work for it
        this._ngZone.run(function () {
            _this.requestReloadBilling.emit();
            _this.userService.triggerUpdateActivatedInfluencers();
        });
    };
    AccountTypeComponent.prototype.reloadPage = function () {
        window.location.reload();
    };
    return AccountTypeComponent;
}());
export { AccountTypeComponent };



// WEBPACK FOOTER //
// ./src/app/main/user/user-billing/account-type/account-type.component.ts.pre-build-optimizer.js